import { newInvoke } from '../../QTBridge';
import { call } from '@popo-bridge/web';
import { ToolTye } from '@/components/Note/utils';
import { Platform } from '@/utils/platform';
import { webEventEmitter } from '../../eventEmitter';

export interface ToolsState {
  toolType: ToolTye;
  enabled: boolean;
}
export interface toolsStateChangedRet {
  toolsState: ToolsState[];
}

/**
 * 工具栏状态发生变化 传回一个数组，数组内标识工具类型 ID, 与可用状态 WEB独有
 * @param params
 */
export const onToolsStateChanged = async (cb: (v: toolsStateChangedRet) => void) => {
  webEventEmitter.addListener('toolsStateChanged', (data) => {
    cb(data);
  });
};
